import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import Copyright from './Copyright';
import CurrentTime from './CurrentTime';
import DynamicIsland from './DynamicIsland';

function Loading() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/home');
    }, 2000);

    return () => clearTimeout(timer); 
  }, [navigate]);

  return (
    <section className="container loading-screen">
      <CurrentTime/>
      <DynamicIsland/>      
      <h1 className="brand-name">CampusEdu</h1>
      <p className="brand-slogan">Keep on Learning</p>
      <h2 className="welcome-message">Welcome!</h2>
      <p className="account-status">Accessing your account</p>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/7e6815281b1ae22967148904ccdd7e6332b98d18fa36430d47e52996ac8a8dc8?placeholderIfAbsent=true&apiKey=cecdc23b6d6043a5a878849a3e1c7153"
        alt="Loading indicator"
        className="loading-icon"
      />
      <p className="loading-text">Loading...</p>
      <Copyright/>
    </section>
  );
}

export default Loading;
